const GA_TERMS_CONDITION_LINKS = {
GUARDIAN_ONLINE_TERMS_AND_CONDITION: "https://www.guardianlife.com/terms-conditions",
PRIVACY_POLICY: "https://www.guardianlife.com/privacy-policy",
AGREEMENT_TO_CONDUCT_BUSINESS: "https://www.guardianlife.com/agreement-conduct-business-electronically"
}

export const COMMON_CONSTANTS = {
  GA_TERMS_CONDITION_LINKS,
};

export const GA_REQUEST_ID_HEADER = "ga-request-id";

export const PHONE_NUMBER_REGEX = /^\d{3}-\d{3}-\d{4}$/;


export const LAUNCH_DARKLY_CLIENT_SIDE_ID = {
  DEV: '670e6bb6c37484083a4699b4',
  PROD: '670e6bb6c37484083a4699b5',
  UATPERF: '670e6c04a904680826283e5a',
  UAT: '670e6bcbadab87084c136327',
};